import { useState } from "react";
import Button from "@/components/Button";
import TableSection from "./components/TableSection";
import "./style.scss";

const Notification = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <div className='notification-page-wrapper'>
        <div className='header-page'>
          <div>
            <h1>Notification</h1>
            <span className='sub-title'>
              Manage notification for user here.
            </span>
          </div>

          <div className='btn-wrapper'>
            <Button
              label='Source'
              size='md'
              startIcon='plus'
              onClick={() => setShowModal(!showModal)}
            />
          </div>
        </div>
        <div className='content'>
          <TableSection setShowModal={setShowModal} showModal={showModal} />
        </div>
      </div>
    </>
  );
};

export default Notification;
